import {useBlocker} from 'react-router';
/** Mount only while this editor owns a draft; other step editors can then own navigation. */
export function OnboardingDraftGuard({busy,uncertain,saved}:{busy:boolean;uncertain:boolean;saved:()=>boolean}){
 const blocker=useBlocker(()=>!saved());
 return blocker.state==='blocked'?<div role="alert"><p>{busy?'Wait for the save confirmation.':'This step has unsaved entries.'}</p><button type="button" onClick={()=>blocker.reset()}>Return to editing</button>{!busy&&!uncertain&&<button type="button" onClick={()=>blocker.proceed()}>Leave without saving</button>}</div>:null;
}
